<script setup lang="ts">
import PortalTarget from '@d/app/components/util/PortalTarget.vue'
import ULoading from '@d/app/components/util/ULoading.vue'
import Auth from '@d/auth/components/auth.vue'
import './style/main.scss'

const head = useLocaleHead({
  dir: true,
  key: 'id',
  seo: true,
})

const { t } = useI18n({
  useScope: 'local',
})

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | ${t('baseTitle')}` : t('baseTitle')
  },
  meta: [{
    name: 'keywords',
    content: '',
  }],
})
</script>

<template>
  <Html :lang="head.htmlAttrs?.lang" :dir="head.htmlAttrs?.dir">
    <Head>
      <template v-for="link in head.link" :key="link.id">
        <Link :id="link.id" :rel="link.rel" :href="link.href" :hreflang="link.hreflang" />
      </template>
      <template v-for="meta in head.meta" :key="meta.id">
        <Meta :id="meta.id" :property="meta.property" :content="meta.content" />
      </template>
    </Head>
    <Body>
      <NuxtLoadingIndicator />
      <PortalTarget id="fullscreen" />
      <Suspense>
        <Auth>
          <NuxtLayout>
            <NuxtPage />
          </NuxtLayout>
        </Auth>
        <template #fallback>
          <ULoading class="loader" />
        </template>
      </Suspense>
    </Body>
  </Html>
</template>

<i18n lang="yaml">
de:
  baseTitle: >-
    knowing:u
en:
  baseTitle: >-
    knowing:u
</i18n>

<style scoped>
#zenuml-intersection-detector-container{
  width: fit-content   !important;
  height: fit-content !important;
}

html{
  overflow: auto
}

.loader {
  display: flex;
  align-content: center;
  justify-content: center;
  height: 100vh;
}
</style>
